module.exports = __webpack_public_path__ + "static/media/freelancerHeroImage@2x.9633c6c9.png";